<template>
    <layout-basic>
        <v-container fluid>
            <v-row>
                <v-col md="12">
                            <v-text-field class="search-box" placeholder="Search Courses" prepend-icon="fa-search"
                                v-model="search" type="text" clearable clear-icon="fa-times" @click:clear="resetSearch"
                                @change="applySearch"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                        <v-data-table :headers="headers" :options.sync="options"
                            :server-items-length="serverItemsLength" v-show="!loading" :items="courses">
                            <template v-slot:item.completion_progress="{ item }">
                                <v-progress-linear height="20" color="blue"
                                    :value="item.completion_progress"></v-progress-linear>
                            </template>
                            <template v-slot:item.id="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" small outlined color="secondary"
                                            :to="'/partner/reports/course/'+item.id" v-if="$globalConfig.APP_NAME === 'senso'">
                                            <v-icon small>fa-search</v-icon>
                                        </v-btn>
                                        <v-btn v-else v-on="on" small outlined color="secondary" :to="'/partner/reports/customer/' +
                                            id +
                                            '/course/' +
                                            item.id +
                                            '/users'
                                            ">
                                            <v-icon small>fa-search</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Details</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </layout-basic>
</template>

<script>
    import partnerAPI from "@/api/partner.js";
    import LayoutBasic from "@/layouts/PartnerHub";
    
    export default {
        name: "CourseReport",
        components: {
            LayoutBasic
        },
        data() {
            return {
                headers: [
                    { text: "Course", value: "name" },
                    {
                        text: "Individual Users",
                        value: "total_enrolled_individual_users",
                        sortable: false
                    },
                    { text: "Groups", value: "total_groups", sortable: false },
                    { text: "Total Users", value: "total_users", sortable: false },
                    { text: "In Progress", value: "total_inprogress", sortable: false },
                    { text: "Completed", value: "total_completed", sortable: false },
                    { text: "Not Started", value: "total_not_started", sortable: false },
                    {
                        text: "Total Completion %",
                        value: "completion_progress",
                        sortable: false
                    },
                    { text: "", value: "id", sortable: false, align: "end" }
                ],
                courses: [],
                search: "",
                pagination: {},
                options: {},
                loading: false,
                searchParams: "",
                id: this.$route.params.id
            };
        },
        computed: {
            serverItemsLength: function() {
                return this.pagination.total;
            },
            itemsPerPage: function() {
                return this.pagination.per_page;
            },
            page: function() {
                return this.pagination.current_page;
            },
            params: function() {
                return this.$gf.getQueryString(this.options, this.serverItemsLength);
            },
            isTabletOrDesktop() {
                const width = this.$vuetify.breakpoint.width;
                return width >= 820;
            },
        },
        watch: {
            options: {
                handler() {
                    this.getCourses();
                },
                deep: true
            }
        },
        methods: {
            applySearch() {
                this.options.page = 1;
                if (this.search != null) {
                    this.searchParams = this.params + "&search=name:" + this.search + "&include=thumbnail,test";
                } else {
                    this.searchParams = this.params + "&include=thumbnai,testl";
                }
                this.getCourses();
            },
            resetSearch() {
                this.options.page = 1;
                this.search = "&include=thumbnail,test";
                this.applySearch();
            },
            getCourses() {
                this.loading = true;
                partnerAPI
                .getCourses(this.params + "&include=thumbnail,test", this.searchParams, this.id)
                .then(resp => {
                    this.courses = resp.data.data;
                    this.pagination = resp.data.meta.pagination;
                    this.loading = false;
                });
            }
        }
    };
</script>
